import { useMemo } from 'react'

import { AccountUserRoles } from '@/models/enums'

import { useUser } from './queries/useUser'

export function useCurrentUser({
  shouldFetch = true,
}: { shouldFetch?: boolean } = {}) {
  const {
    data: user,
    isFetching,
    isLoading,
  } = useUser({
    enabled: shouldFetch,
  })

  const canManageTeam = useMemo(
    () => !isFetching && user?.accountRoleId !== AccountUserRoles.MEMBER,
    [user?.accountRoleId, isFetching],
  )

  return {
    currentUser: user,
    isLoading: isFetching,
    canManageTeam,
    isFirstLoad: isLoading,
  }
}
